export default __webpack_public_path__ + "static/media/Idle (8).ab5490cb.png";